// id — человекочитаемый slug; detailsKey — ключ для полного описания (i18n)
import icon1  from '../assets/ready-solutions-1.png';
import icon2  from '../assets/ready-solutions-2.png';
import icon3  from '../assets/ready-solutions-3.png';
import icon4  from '../assets/ready-solutions-4.png';
import icon5  from '../assets/ready-solutions-5.png';
import icon6  from '../assets/ready-solutions-6.png';
import icon7  from '../assets/ready-solutions-7.png';
import icon8  from '../assets/ready-solutions-8.png';
import icon9  from '../assets/ready-solutions-9.png';
import icon10 from '../assets/ready-solutions-10.png';
import icon11 from '../assets/ready-solutions-11.png';
import icon12 from '../assets/ready-solutions-12.png';
import icon13 from '../assets/ready-solutions-13.png';
import icon14 from '../assets/ready-solutions-14.png';
import icon15 from '../assets/ready-solutions-15.png';
import icon16 from '../assets/ready-solutions-16.png';
import icon17 from '../assets/ready-solutions-17.png';
import icon18 from '../assets/ready-solutions-18.png';

export const readySolutions = [
  { id: 'rs-1',  image: icon1,  titleKey: '$BP_name_1',  descKey: '$BP_desc_1',  detailsKey: '$BP_full_1' },
  { id: 'rs-2',  image: icon2,  titleKey: '$BP_name_2',  descKey: '$BP_desc_2',  detailsKey: '$BP_full_2' },
  { id: 'rs-3',  image: icon3,  titleKey: '$BP_name_3',  descKey: '$BP_desc_3',  detailsKey: '$BP_full_3' },
  { id: 'rs-4',  image: icon4,  titleKey: '$BP_name_4',  descKey: '$BP_desc_4',  detailsKey: '$BP_full_4' },
  { id: 'rs-5',  image: icon5,  titleKey: '$BP_name_5',  descKey: '$BP_desc_5',  detailsKey: '$BP_full_5' },
  { id: 'rs-6',  image: icon6,  titleKey: '$BP_name_6',  descKey: '$BP_desc_6',  detailsKey: '$BP_full_6' },
  { id: 'rs-7',  image: icon7,  titleKey: '$BP_name_7',  descKey: '$BP_desc_7',  detailsKey: '$BP_full_7' },
  { id: 'rs-8',  image: icon8,  titleKey: '$BP_name_8',  descKey: '$BP_desc_8',  detailsKey: '$BP_full_8' },
  { id: 'rs-9',  image: icon9,  titleKey: '$BP_name_9',  descKey: '$BP_desc_9',  detailsKey: '$BP_full_9' },
  { id: 'rs-10', image: icon10, titleKey: '$BP_name_10', descKey: '$BP_desc_10', detailsKey: '$BP_full_10' },
  { id: 'rs-11', image: icon11, titleKey: '$BP_name_11', descKey: '$BP_desc_11', detailsKey: '$BP_full_11' },
  { id: 'rs-12', image: icon12, titleKey: '$BP_name_12', descKey: '$BP_desc_12', detailsKey: '$BP_full_12' },
  { id: 'rs-13', image: icon13, titleKey: '$BP_name_13', descKey: '$BP_desc_13', detailsKey: '$BP_full_13' },
  { id: 'rs-14', image: icon14, titleKey: '$BP_name_14', descKey: '$BP_desc_14', detailsKey: '$BP_full_14' },
  { id: 'rs-15', image: icon15, titleKey: '$BP_name_15', descKey: '$BP_desc_15', detailsKey: '$BP_full_15' },
  { id: 'rs-16', image: icon16, titleKey: '$BP_name_16', descKey: '$BP_desc_16', detailsKey: '$BP_full_16' },
  { id: 'rs-17', image: icon17, titleKey: '$BP_name_17', descKey: '$BP_desc_17', detailsKey: '$BP_full_17' },
  { id: 'rs-18', image: icon18, titleKey: '$BP_name_18', descKey: '$BP_desc_18', detailsKey: '$BP_full_18' },
];
